export enum AnimcoTypeEnum {
    MOBILE_RECOVERY = 'mobile_recovery',
    PROMO_CODE = 'promo_code',
    DISCOUNT = 'discount',
    DEFERED_DISCOUNT = 'defered_discount',
    OTHER = 'other',
}

export interface PalpatineProduct {
    Slug: string;
    highlight?: {
        items: PalpatineProductHighlights[];
    };
    stickers?: {
        items: PalpatineProductStickers[];
    };
    anim_animco_list: {
        items: {
            type: AnimcoTypeEnum;
            promo_code?: string;
            text: string;
            tooltip?: string;
            start_date?: string;
            end_date?: string;
            order: number;
            parcours: string[];
        }[];
    };
    banner_animco_list: {
        items: {
            display_sticker: boolean;
            sticker_value: string;
            sticker_color?: string;
            text: string;
            start_date?: string;
            end_date?: string;
            parcours: string[];
            inverted?: boolean;
            tracking?: string;
        }[];
    };
}

export interface PalpatineFilterModel {
    id: string;
    title: string | null;
    subtitle: string | null;
    link_seo:
        | {
              title_product: string | null;
          }[]
        | null;
}

export interface PalpatineBonusPlan {
    id: number;
    forfait_bonus_reprise: string;
}

export type PhoneWallPlanTarget = 'with_plan' | 'no_plan';

export interface PalpatineProductHighlights {
    start_date?: string;
    end_date?: string;
    parcours: ('ACQUISITION' | 'RENOUVELLEMENT')[];
    label_price: number | null;
    label_price_exponent: string | null;
    stamp: { public_url: string } | null;
    stamp_alt: string | null;
    phone_wall_plan_target?: PhoneWallPlanTarget[];
}

export interface PalpatineProductStickers {
    name: string;
    sticker_text: string;
    sticker_color: string;
    start_date?: string;
    end_date?: string;
    id: number;
    parcours: ('ACQUISITION' | 'RENOUVELLEMENT')[];
    phone_wall_plan_target?: PhoneWallPlanTarget[];
}

export type PalpatineStickerItemType = {
    id: number;
    order: number;
    format_mdt: 'simple' | 'double';
    start_date?: string;
    end_date?: string;
};

export type PalpatineStickerType<T extends PalpatineStickerItemType> = {
    id: string;
    slug: string;
    animco_banner: {
        items: T[];
    };
};

export type PalpatinePlanType = {
    id: string;
    slug: string;
    text_popin: string;
    acq_renew: ('acquisition' | 'renouvellement')[];
    forfait_details: { icone_trilogy: string; pepite: string }[];
};

export type PalpatineDetailedPlanType = {
    id: string;
    gencode: string;
    add_pepites:
        | {
              icon_trilogy: string | null;
              pepite: string | null;
          }[]
        | null;
    big_benefit_text: string | null;
    phone_benefit_text: string | null;
    phone_benefit_icon: string | null;
    modal_destination_custom_partial: string | null;
};
